<script>
import TemplateString from "@shared/components/TemplateString.svelte"

export let content = ""
</script>

<p class="p text {$$props.className || ''}">
  <TemplateString content="{content}" />
</p>
